import { GridContainer } from '@/components/grid-container/grid-container';
import { Text } from '@/components/text/text';
import { EnterAnimation } from '@/components/enter-animation/enter-animation';
import { styled } from '@/stitches.config';
import { DesktopOverview } from './desktop-overview';
import { MobileOverview } from './mobile-overview';
import { slugify } from '@/utils/slugify';
import { type WorkSubsection } from '@/lib/schemas/work-subsection';

type WorkSubsectionProps = {
  subsection: WorkSubsection;
  canAnimate: boolean;
};

export function WorkSubsection(props: WorkSubsectionProps) {
  const slugId = slugify(props.subsection.subcategory.name);

  return (
    <GridContainer
      css={{
        '&:not(:first-child)': {
          my: '$12',
          '@bp4': {
            my: '$13',
          },
        },
      }}
    >
      <WorkSubsectionWrapper>
        <Description id={slugId}>
          <EnterAnimation>
            <Text
              as="h2"
              size={{
                '@initial': 4,
                '@bp4': 6,
              }}
            >
              {props.subsection.subcategory.name}
            </Text>
            <Text
              as="p"
              size={2}
              css={{
                '@bp2': {
                  maxWidth: '50%',
                },
                '@bp4': {
                  maxWidth: 'initial',
                },
              }}
            >
              {props.subsection.subcategory.description}
            </Text>
          </EnterAnimation>
        </Description>
        <MobileOverview
          subsection={props.subsection}
          canAnimate={props.canAnimate}
        />
        <DesktopOverview
          subsection={props.subsection}
          canAnimate={props.canAnimate}
        />
      </WorkSubsectionWrapper>
    </GridContainer>
  );
}

const WorkSubsectionWrapper = styled('section', {
  '@bp4': {
    display: 'contents',
  },
});

const Description = styled('div', {
  fontSize: '$2',
  overflowWrap: 'anywhere',
  scrollMarginTop: '$9',

  '@bp4': {
    gridColumn: '2 / span 5',
    alignSelf: 'start',
    position: 'sticky',
    top: '$12',
    // desktop-cards component has an inset: '$4', on this breakpoint
    // And we want to keep the description aligned with it
    paddingTop: '$4',
  },

  '@bp5': {
    gridColumn: '2 / span 4',
    paddingRight: '$6',
  },

  p: {
    lineHeight: '$6',
  },
});
